module.exports = __webpack_public_path__ + "static/smokin-59b6f86a9604d51e5ba185f5e8146df9.mp4";